import { render, staticRenderFns } from "./RatingConfig.vue?vue&type=template&id=3e38d1cb&scoped=true"
import script from "./RatingConfig.vue?vue&type=script&lang=js"
export * from "./RatingConfig.vue?vue&type=script&lang=js"
import style0 from "./RatingConfig.vue?vue&type=style&index=0&id=3e38d1cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e38d1cb",
  null
  
)

export default component.exports